<script>
import store from '@state/store'
import Layout from '@layouts/loggedin.vue'
import UserHeader from '@users/components/user-header.vue'
import { authComputed } from '@state/helpers'
import Tab from '@router/components/tab.vue'
import Tabs from '@router/components/tabs.vue'
import EventTile from '@events/components/event-tile.vue'
import PostFeed from '@router/components/post-feed.vue'
import { POSTS_PER_PAGE } from '@/src/router/constant'
import ProfileTab from '@router/components/profile-tab.vue'

export default {
  components: {
    Layout,
    UserHeader,
    Tab,
    Tabs,
    EventTile,
    PostFeed,
    ProfileTab,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    postsCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      filterStatusUpdates: false,
      loadingMore: false,
      noMorePosts: false,
      activeTab: 1,
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    statusUpdates() {
      var statusUpdates = this.$store.state.users.statusUpdates || []
      if (this.filterStatusUpdates) {
        statusUpdates = statusUpdates.filter(
          (statusUpdate) => statusUpdate.type === this.filterStatusUpdates
        )
      }

      return statusUpdates
    },
    toggleOverlay(params) {
      this.showOverlay = params.showHide
    },
    fetchMoreStatusUpdates() {
      if (this.activeTab === 1 || this.postsCount < POSTS_PER_PAGE)
        return (this.noMorePosts = true)

      this.loadingMore = true
      store
        .dispatch('users/fetchStatusUpdates', {
          userId: this.user.id,
        })
        .then((posts) => {
          this.loadingMore = false
          this.noMorePosts = !posts.length
        })
        .catch(() => {})
    },
    changedTab(params) {
      this.activeTab = params.index
    },
  },
}
</script>

<template>
  <Layout>
    <UserHeader :user="user"></UserHeader>
    <div class="w-content h-auto flex bg-blue-lightest  ">
      <Tabs
        :classes="'flex justify-between'"
        :parent-classes="'w-content bg-white flex justify-center'"
        :tab-classes="
          'border-b-5 pb-5 text-xl mx-8 leading-loose cursor-pointer'
        "
        @changed-tab="changedTab"
      >
        <Tab
          title='<svg id="Group_254" data-name="Group 254" xmlns="http://www.w3.org/2000/svg" width="29.422" height="25.443" viewBox="0 0 29.422 25.443" class="inline-block align-middle mr-2"><path id="Path_113" data-name="Path 113" d="M35.848,14.5H15.673a2.493,2.493,0,0,0-2.508,2.508v1.075H11.408A2.493,2.493,0,0,0,8.9,20.592V37a2.92,2.92,0,0,0,2.759,2.938H35.382A2.952,2.952,0,0,0,38.321,37v-20A2.463,2.463,0,0,0,35.848,14.5ZM13.164,37.112a1.3,1.3,0,0,1-.43,1,1.561,1.561,0,0,1-1.039.394A1.466,1.466,0,0,1,10.333,37V20.592a1.056,1.056,0,0,1,1.075-1.075h1.756ZM36.923,37a1.514,1.514,0,0,1-1.505,1.505H14.239a5.076,5.076,0,0,0,.287-.645v-.072c.036-.072.036-.179.072-.287v-.072c0-.108.036-.215.036-.358V17.008a1.056,1.056,0,0,1,1.075-1.075H35.848a1.056,1.056,0,0,1,1.075,1.075Z" transform="translate(-8.9 -14.5)" fill="#069bd7"/><path id="Path_114" data-name="Path 114" d="M65.269,36.1H58.317a.717.717,0,0,0,0,1.433h6.952a.717.717,0,1,0,0-1.433Z" transform="translate(-40.148 -28.36)" fill="#069bd7"/><path id="Path_115" data-name="Path 115" d="M65.269,47.6H58.317a.717.717,0,0,0,0,1.433h6.952a.717.717,0,1,0,0-1.433Z" transform="translate(-40.148 -35.739)" fill="#069bd7"/><path id="Path_116" data-name="Path 116" d="M48.137,59.1H31.617a.717.717,0,1,0,0,1.433h16.52a.717.717,0,0,0,0-1.433Z" transform="translate(-23.016 -43.117)" fill="#069bd7"/><path id="Path_117" data-name="Path 117" d="M65.269,24.5H58.317a.717.717,0,0,0,0,1.433h6.952a.717.717,0,1,0,0-1.433Z" transform="translate(-40.148 -20.916)" fill="#069bd7"/><path id="Path_118" data-name="Path 118" d="M48.137,70.7H31.617a.717.717,0,1,0,0,1.433h16.52a.717.717,0,0,0,0-1.433Z" transform="translate(-23.016 -50.561)" fill="#069bd7"/><path id="Path_119" data-name="Path 119" d="M31.617,34.211h6.307a.719.719,0,0,0,.717-.717V25.217a.719.719,0,0,0-.717-.717H31.617a.719.719,0,0,0-.717.717v8.278A.719.719,0,0,0,31.617,34.211Zm.717-8.278h4.874v6.845H32.333Z" transform="translate(-23.016 -20.916)" fill="#069bd7"/></svg><span class="align-middle">News Feed</span>'
        >
          <div class="h-auto flex mt-16 pl-15 pr-15 justify-center w-content">
            <div
              class="left-posts w-7/12 bg-white rounded-xl shadow-box relative"
            >
              <div class="absolute top-0" style="right:-10.25rem;">
                <div class="text-blue-darker text-basel">Filter By:</div>
                <button
                  class="text-blue text-lg block"
                  @click="filterStatusUpdates = false"
                  >All</button
                >
                <button
                  class="text-blue text-lg block"
                  @click="filterStatusUpdates = 'gratitude'"
                  >Gratitude</button
                >
                <button
                  class="text-blue text-lg block"
                  @click="filterStatusUpdates = 'volunteered'"
                  >Volunteer Hours</button
                >
                <button
                  class="text-blue text-lg block"
                  @click="filterStatusUpdates = 'kyndness'"
                  >Acts of Kyndness</button
                >
                <button
                  class="text-blue text-lg block"
                  @click="filterStatusUpdates = 'donation'"
                  >Donation</button
                >
              </div>
              <PostFeed
                :status-updates="statusUpdates()"
                :loading-more="loadingMore"
                :no-more-posts="noMorePosts"
                @fetch-more-status-updates="fetchMoreStatusUpdates"
              ></PostFeed>
            </div>
          </div>
        </Tab>
        <Tab
          v-if="user.id === currentUserId"
          title='<svg xmlns="http://www.w3.org/2000/svg" width="27.499" height="26.31" viewBox="0 0 27.499 26.31" class="inline-block align-middle mr-2"><path id="Path_120" data-name="Path 120" d="M35.824,22.983H30.556V20.092a.675.675,0,0,0-1.35,0v2.891H16.293V20.092a.675.675,0,0,0-1.35,0v2.891H9.675A.676.676,0,0,0,9,23.658V45.052a.676.676,0,0,0,.675.675H35.824a.676.676,0,0,0,.675-.675V23.658A.676.676,0,0,0,35.824,22.983Zm-.675,21.394H10.35V31.464h24.8Zm0-14.263H10.35V24.333h4.593v1.7a.675.675,0,0,0,1.35,0v-1.7H29.206v1.7a.675.675,0,0,0,1.35,0v-1.7h4.593Z" transform="translate(-9 -19.417)" fill="#00638a"/></svg><span class="align-middle">Events</span>'
        >
          <div class="h-auto mt-17 my-7.7 w=content">
            <div class="flex events-grid">
              <div
                v-for="oneEvent in user.opportunities"
                :key="oneEvent.id"
                class="event-box-wrapper"
              >
                <EventTile
                  :one-event="oneEvent"
                  @open-modal="openEventModal(oneEvent)"
                ></EventTile>
              </div>
            </div>
          </div>
        </Tab>
        <Tab
          title='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21.044 24.049" class="inline-block align-middle"><g id="Group_244" data-name="Group 244" transform="translate(-453.062 -37.45)"><path id="Path_109" data-name="Path 109" d="M463.593,50.506a6.528,6.528,0,1,0-6.529-6.528A6.546,6.546,0,0,0,463.593,50.506Zm-5.133-6.528a5.139,5.139,0,0,1,5.133-5.133l.133,0a5.135,5.135,0,1,1-5.266,5.135Z" fill="#00638A"/><path id="Path_110" data-name="Path 110" d="M463.584,50.727a10.534,10.534,0,0,0-10.522,10.522v.25h1.4v-.25a9.139,9.139,0,0,1,9.123-9.123h0a9.126,9.126,0,0,1,9.127,9.123v.25h1.15v-.25h.24A10.534,10.534,0,0,0,463.584,50.727Z" fill="#00638A"/></g></svg> <span class="align-middle">Profile</span>'
        >
          <div class="h-auto flex mt-16 pl-15 pr-15 justify-center w-content">
            <div
              class="left-posts w-8/12 bg-white rounded-xl shadow-box relative px-12 py-12 mb-6"
            >
              <ProfileTab :user="currentUser" />
            </div>
          </div>
        </Tab>
        <Tab
          title='<svg id="Group_263" data-name="Group 263" xmlns="http://www.w3.org/2000/svg" width="41.324" height="29.621" viewBox="0 0 41.324 29.621" class="inline-block align-middle mr-2"><path id="Path_123" data-name="Path 123" d="M50.145,19.3H48.7v4.816h.578a5.235,5.235,0,0,1,.867.048Z" transform="translate(-28.664 -19.3)" fill="#00638a"/><path id="Path_124" data-name="Path 124" d="M11.579,38.52,8.16,35.1c-.337.337-.722.674-1.06,1.011l3.42,3.42C10.857,39.194,11.194,38.857,11.579,38.52Z" transform="translate(-7.1 -27.49)" fill="#00638a"/><path id="Path_125" data-name="Path 125" d="M27.249,23.1c-.433.193-.915.337-1.349.53l1.83,4.479a11.217,11.217,0,0,1,1.349-.53Z" transform="translate(-16.845 -21.27)" fill="#00638a"/><path id="Path_126" data-name="Path 126" d="M83.7,38.92l1.011,1.011,3.42-3.42L87.12,35.5Z" transform="translate(-46.807 -27.698)" fill="#00638a"/><path id="Path_127" data-name="Path 127" d="M69.53,23.3,67.7,27.779c.433.193.915.337,1.349.578l1.83-4.479C70.445,23.685,69.964,23.493,69.53,23.3Z" transform="translate(-38.513 -21.373)" fill="#00638a"/><path id="Path_128" data-name="Path 128" d="M48.549,45.352l.193-.385-.193-.385a21.78,21.78,0,0,0-37.857.048l-.193.385.193.385a21.828,21.828,0,0,0,37.857-.048Zm-36.412-.385a20.626,20.626,0,0,1,13.149-9.392,10.336,10.336,0,0,0,0,18.784A20.293,20.293,0,0,1,12.138,44.967Zm8.573,0a8.91,8.91,0,1,1,8.91,8.91A8.921,8.921,0,0,1,20.711,44.967Zm13.245,9.44a10.336,10.336,0,0,0,0-18.784A20.747,20.747,0,0,1,47.1,45.015,20.87,20.87,0,0,1,33.956,54.407Z" transform="translate(-8.862 -26.713)" fill="#00638a"/></svg><span class="align-middle">Interests</span>'
        >
          <div class="h-auto flex mt-16 pl-15 pr-15 justify-center">
            <div
              class="left-posts w-8/12 bg-white rounded-xl shadow-box relative px-12 py-12 mb-6"
            >
              <div class="text-blue-darker text-base mb-2 ml-4">
                Organizations:
              </div>
              <div class="flex justify-start mb-6 flex-wrap">
                <div
                  v-for="org in user.organizations"
                  :key="org.id"
                  class="bg-gray-lightest text-blue-darker rounded-comments leading-tight w-50 h-16 py-6 px-6 mx-4 mb-7.5 truncate"
                  ><router-link
                    :to="{
                      name: 'organization',
                      params: { organizationId: org.id },
                    }"
                  >
                    <img
                      v-if="org.image_url !== ''"
                      :src="org.image_url"
                      class="rounded-full w-5 h-5 inline-block align-middle"
                    />
                    {{ org.name }}
                  </router-link>
                </div>
                <div
                  v-if="user.organizations.length === 0"
                  class="ml-4"
                >
                  Search for an organizations or choose any you see in the posts
                  feed to follow
                </div>
              </div>
              <div class="text-blue-darker text-base mb-2 ml-4">
                Causes:
              </div>
              <div class="flex justify-start mb-6 flex-wrap">
                <div
                  v-for="cause in user.causes"
                  :key="cause.id"
                  class="bg-gray-lightest text-blue-darker rounded-comments leading-tight w-50 h-16 py-6 px-6 mx-4 mb-7.5 truncate"
                  ><router-link
                    :to="{
                      name: 'cause',
                      params: { causeId: cause.id },
                    }"
                  >
                    {{ cause.name }}
                  </router-link>
                </div>
                <div v-if="user.causes.length === 0" class="ml-4">
                  Search for causes or choose any you see in the posts feed to
                  follow
                </div>
              </div>
              <div class="text-blue-darker text-base mb-2 ml-4">
                Tags:
              </div>
              <div class="flex justify-start mb-6 flex-wrap">
                <div
                  v-for="tag in user.tags"
                  :key="tag.id"
                  class="bg-gray-lightest text-blue-darker rounded-comments leading-tight w-50 h-16 py-6 px-6 mx-4 mb-7.5 truncate"
                  ><router-link
                    :to="{
                      name: 'tag',
                      params: { tagId: tag.id },
                    }"
                  >
                    {{ tag.name }}
                  </router-link>
                </div>
                <div v-if="user.tags.length === 0" class="ml-4">
                  Search for a tag or choose any you see in the posts feed to
                  follow
                </div>
              </div>
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  </Layout>
</template>
